
import './App.css';
import AppRoutes from './routes/AppRoutes'; 

function App() {
  return (
    <div className="App">
      <header className="App-header">
          <AppRoutes />
      </header>
    </div>
  );
}

export default App;
